import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDBet implements ICommand
{

	public betType : number = 0;
	public betAmount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.betType = ba.readUint8();
		this.betAmount = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.betType);
		ba.writeUint53(this.betAmount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDBet();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'betType(B)='+this.betType+' ';
		str += 'betAmount(Q)='+this.betAmount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'Bet';
	}

}
